import { compact, filter, find, flow, head, isEmpty, map, toLower } from 'lodash/fp';

import { Country, LocationResult } from '../../types';
import getIsMatch from '../get-is-match';

const filterCitiesByCountry = ({ country, searchTerm }: { country: Country; searchTerm: string }) =>
  filter((city) => getIsMatch(searchTerm, city.label), country.cities);

const getMatchedCitiesFromCountry = (matchedCountry: Country, searchTerm: string, hasMatchedCountry: boolean) => {
  if (!matchedCountry) {
    return null;
  }
  const cityMatches = filterCitiesByCountry({ country: matchedCountry, searchTerm });

  if (!isEmpty(cityMatches)) {
    const { region, id, label } = matchedCountry;
    const city = head(cityMatches);
    return {
      city,
      country: label,
      hasMatchedCountry,
      label: `${label} (${city?.label})`,
      value: `${region}-${id}-${city?.id}`,
    };
  }
  return null;
};

const getMatchedCities = ({
  searchTerm,
  countries,
  countryLabel,
}: {
  searchTerm: string;
  countries: Country[];
  countryLabel?: string;
}) => {
  if (countryLabel) {
    const matchedCountry = find((country) => toLower(country.label) === toLower(countryLabel), countries) as Country;
    return [getMatchedCitiesFromCountry(matchedCountry, searchTerm, true)] as LocationResult[];
  }
  return flow(
    map((country: Country) => getMatchedCitiesFromCountry(country, searchTerm, false)),
    compact,
  )(countries) as LocationResult[];
};

export default getMatchedCities;
